import { DownloadPageLayout } from '@bpm-web-app/components';
import { MyPlaylists } from '@bpm-web-app/components/pages';

export default function MyPlaylistsPage({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title} hasHubSwitch={false}>
            <MyPlaylists />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'My Playlists',
        },
    };
}
